export default class Timeline {
	private readonly container: HTMLElement = document.querySelector('.timeline');
	private items: NodeListOf<HTMLElement>;
	private nav: HTMLElement;
	private navCurr: number;
	private navNext: HTMLElement;
	private navPrev: HTMLElement;
	private navTarget?: HTMLElement;
	private scrolling: any;
	private scrollOffset: number;
	private slider: HTMLElement;
	private activeClassName: string = 'active';

	constructor() {
		if (!this.container) {
			return;
		}
		this.nav = this.container.querySelector('.timeline__controls');
		this.items = this.container.querySelectorAll('.timeline__item[tabindex="0"]');
		this.slider = this.container.querySelector('.timeline__items');
		this.scrollOffset = document.documentElement.clientWidth / 2;

		this.createNav();
		this.setupEventHandlers();
		this.setupSlider();
		this.selectIndex(0);
	}
	createNav() {
		this.nav.insertAdjacentHTML("afterbegin", `
			<button class="prev"><b>‹</b> <span>Prev</span></button>
			<button class="next"><span>Next</span> <b>›</b></button>
		`);
		this.navPrev = this.nav.querySelector('button.prev');
		this.navNext = this.nav.querySelector('button.next');

		this.navNext.addEventListener('click', () => {
			this.selectIndex(this.navCurr + (this.navCurr == this.items.length - 1 ? 0 : 1));
		});
		this.navPrev.addEventListener('click', () => {
			this.selectIndex(this.navCurr - (this.navCurr == 0 ? 0 : 1));
		});
	}
	selectIndex(index: number) {
		/*DEBUG*/console.log('selectIndex', this.navCurr === index, index);
		if (this.navCurr === index) {
			this.items[this.navCurr].classList.add(this.activeClassName);
			return;
		}

		this.navTarget = this.items[index];
		this.items[this.navCurr ? this.navCurr : 0].classList.remove(this.activeClassName);
		this.navCurr = index;
	}
	setupEventHandlers() {
		this.slider.addEventListener('animationend', event => {
			if (this.navTarget !== undefined) {
				if (event.animationName === 'timeline-disc-reset') {
					window.clearTimeout(this.scrolling);
					this.scrolling = setTimeout(() => {
						this.navTarget.classList.add(this.activeClassName);
						this.navTarget = undefined;
					}, 66);


					let left = (this.navTarget.offsetLeft + (this.navTarget.getBoundingClientRect().width / 2)) * -1;
					this.slider.style.transform = 'translateX('+left+'px)';
				}
			} else {
				// /*DEBUG*/console.log('navTarget is undefined');
			}
		}, true);

		// individual item click
		for (let i = 0, l = this.items.length; i < l; i++){
			let item = (this.items[i]);
			item.setAttribute('data-index', i.toString());
			item.addEventListener('click', (event)=>{
				let target = (event.target as HTMLElement);
				while (!target.classList.contains('timeline__item')) {
					target = target.parentElement;
				}
				this.selectIndex(parseInt(target.getAttribute('data-index')));
			});
			item.addEventListener('focusin', (event)=>{
				item.classList.add('hasFocus');
			});
			item.addEventListener('focusout', (event)=>{
				item.classList.remove('hasFocus');
			});
			item.addEventListener('mouseenter', (event)=>{
				item.classList.add('hasHover');
			});
			item.addEventListener('mouseleave', (event)=>{
				item.classList.remove('hasHover');
			});
		}
	}
	setupSlider(){
		this.slider.classList.add('js-setup')
		this.slider.style.minWidth = document.documentElement.clientWidth + 'px';
	}
}
